import { jsx, jsxs } from "react/jsx-runtime";
import { XStack, YStack, ZStack } from "tamagui";
function StacksDemo() {
  return /* @__PURE__ */ jsxs(XStack, { maxWidth: 250, padding: "$2", alignSelf: "center", space: true, children: [
    /* @__PURE__ */ jsxs(
      YStack,
      {
        flex: 1,
        space: "$2",
        borderWidth: 2,
        borderColor: "$color",
        borderRadius: "$4",
        padding: "$2",
        children: [
          /* @__PURE__ */ jsx(YStack, { backgroundColor: "$color", borderRadius: "$3", padding: "$2" }),
          /* @__PURE__ */ jsx(YStack, { backgroundColor: "$color", borderRadius: "$3", padding: "$2" }),
          /* @__PURE__ */ jsx(YStack, { backgroundColor: "$color", borderRadius: "$3", padding: "$2" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      XStack,
      {
        flex: 1,
        space: "$2",
        borderWidth: 2,
        borderColor: "$color",
        borderRadius: "$4",
        padding: "$2",
        children: [
          /* @__PURE__ */ jsx(YStack, { backgroundColor: "$color", borderRadius: "$3", padding: "$2" }),
          /* @__PURE__ */ jsx(YStack, { backgroundColor: "$color", borderRadius: "$3", padding: "$2" }),
          /* @__PURE__ */ jsx(YStack, { backgroundColor: "$color", borderRadius: "$3", padding: "$2" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(ZStack, { maxWidth: 50, maxHeight: 85, width: 100, flex: 1, children: [
      /* @__PURE__ */ jsx(YStack, { fullscreen: true, borderWidth: 2, borderRadius: "$4", padding: "$2" }),
      /* @__PURE__ */ jsx(YStack, { fullscreen: true, y: 10, x: 10, borderWidth: 2, borderRadius: "$4", padding: "$2" }),
      /* @__PURE__ */ jsx(
        YStack,
        {
          fullscreen: true,
          y: 20,
          x: 20,
          borderWidth: 2,
          backgroundColor: "$color",
          borderRadius: "$4",
          padding: "$2"
        }
      )
    ] })
  ] });
}
export {
  StacksDemo
};
//# sourceMappingURL=StacksDemo.js.map
